import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { createPortal } from "react-dom";

const SurveyRenameModal = ({ isOpen, onClose, onSubmit, surveyData = "", title = "Rename Form", placeholder = "Enter form name" }) => {
  const [surveyTitle, setSurveyTitle] = useState(surveyData?.title || "");
  const [isSaving, setIsSaving] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!surveyTitle.trim() || isSaving) return;
    setIsSaving(true);
    try {
      await onSubmit(surveyData.surveyId, surveyTitle.trim());
      onClose();
    } catch {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    setSurveyTitle(surveyData?.title || "");
    setIsSaving(false);
  }, [surveyData]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-white/80 flex items-center justify-center z-[9999]"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-8 w-full max-w-md relative shadow-2xl border border-line"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-6 top-6 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full p-1.5 transition-all"
        >
          <X size={20} />
        </button>

        <h2 className="text-xl font-normal mb-6 text-black">{title}</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <div className="relative">
              <input
                type="text"
                value={surveyTitle}
                onChange={(e) => {
                  setSurveyTitle(e.target.value);
                }}
                maxLength={100}
                className="text-black text-sm w-full pl-4 pr-16 py-2.5 border border-gray-300 rounded-lg 
                  outline-none focus:outline-none focus:ring-2 focus:ring-[#f9f3a8] focus:border-gray-300 focus:ring-offset-0
                  transition-all duration-200"
                placeholder={placeholder}
                autoFocus
              />
              <div className="absolute right-3 top-1/2 -translate-y-1/2 text-sm pointer-events-none">
                <span className="text-gray-700">{surveyTitle.length}</span>
                <span className="text-gray-400">/100</span>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg font-medium transition-colors border border-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!surveyTitle.trim() || isSaving}
              className="flex-1 px-4 py-2 bg-black text-white rounded-lg font-medium hover:bg-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default SurveyRenameModal;
